import { FormationCard } from './FormationCard';
import { useFormations } from '@/hooks/useSupabase';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

interface RelatedFormationsProps {
  currentFormationId: string;
  category: string;
}

export function RelatedFormations({
  currentFormationId,
  category,
}: RelatedFormationsProps) {
  const { locale } = useParams<{ locale: string }>();
  const { t, i18n } = useTranslation('formationDetail');
  const currentLocale = locale || i18n.language || 'fr';
  const { data: formations } = useFormations();

  // Filter out current formation and limit to 3
  const relatedFormations = formations
    ?.filter((formation) => formation.id !== currentFormationId)
    .slice(0, 3);

  if (!relatedFormations || relatedFormations.length === 0) {
    return null;
  }

  return (
    <section className="py-24 bg-white">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-3xl font-heading font-extrabold text-aspexit-black mb-8 text-center">
            {t('relatedFormations')}
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {relatedFormations.map((formation) => (
              <FormationCard
                key={formation.id}
                slug={formation.slug}
                title={formation.title}
                description={formation.description}
                image={formation.image}
                duration_hours={formation.duration_hours}
                duration_days={formation.duration_days}
                price_ttc={formation.price_ttc}
                category={formation.category}
                mode="distanciel"
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
